export default __webpack_public_path__ + "static/media/pngegg_1.f52fa3da.svg";